import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=5bc996d2&scoped=true&lang=pug&"
import script from "./TopBar.vue?vue&type=script&lang=js&"
export * from "./TopBar.vue?vue&type=script&lang=js&"
import style0 from "./TopBar.scss?vue&type=style&index=0&id=5bc996d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc996d2",
  null
  
)

export default component.exports